export default {
  common: {
    login: "登录",
    userName: "用户名",
    password: "密码",
    rememberPassword: "记住账号密码",
    modifyPassword: "修改密码",
    accountRegister: "账号注册",
    pleaseInput: "请输入",
    loginErrorCheckNamePassword: "登录失败，请检查用户名和密码",
    guest: "访客",
    superAdmin: "超级管理员",
    logOut: "登出",
    inputUserName: "请输入用户名",
    inputPassword: "请输入密码",

    modifySuccessfully: "修改密码成功!",

    using: "使用",
    toLogin: "来进行登录",
    noOktaLoginUrl: "没有找到 OKTA 的登录链接",
    uncheckSwitch: "取消复选框可切换的常规登录模式",

    noADLoginUrl: "没有找到 Azure AD 的登录链接"
  },
  register: {
    email: "电子邮箱地址",
    confirmPassword: "确认密码",
    register: "注册",
    emailRequire: "请输入邮箱",
    passwordRequire: "请输入密码",
    confirmPasswordRequire: "请输入确认密码",
    passwordInconsistency: "密码不一致",
    registeredSuccessfully: "注册成功,",
    jumpToLoginPage: "系统将自动为您跳转到登录页面。",
    contactAdminActivate: "请在登录前，先联系管理员为您激活账号。",
    USER_EXISTS: "用户已存在",

    emailExists: "电子邮箱已存在",
    emailInconsistency: "电子邮箱不一致",
    confirmEmailAddress: "确认电子邮箱地址",
    emailAgain: "请再次输入电子邮箱地址",
    approvedCarrierOnly: "仅限经批准的 Carrier 员工使用。"
  },
  my: {
    about: "关于",
    language: "语言",
    nomenclatureList: "术语表",

    appName: "应用名称",
    version: "版本号",
    iecmFF: "iECM功能框架",
    paragraph1: "1. 基线估算方法完全符合国际性能测量和验证协议（IPMVP），每种方法都符合IPMVP指南，以确保可靠和透明的能源性能评估。",
    paragraph2: "2. 当前库使用基于AHRI条件的性能曲线。",
    paragraph3: "3. 允许为改装后的冷水机组输入AHRI认证的e-CAT性能。",

    learningCenter: "学习中心",
    learningCenterDescription: "访问教程视频、用户手册和工作流程指南，帮助您更有效地使用 iECM。"
  }
}



// WEBPACK FOOTER //
// ./src/locale/login/zh.js